import React from 'react';
import { Building2, Clock3, House, MapPin } from 'lucide-react';
import { Badge } from '../ui/Badge';
const highlights = [{
  icon: House,
  label: 'Residential'
}, {
  icon: Building2,
  label: 'Contractor'
}, {
  icon: Clock3,
  label: 'Same/next-day delivery'
}];
export function ServiceArea() {
  return <section id="service-areas" className="w-full border-y border-border bg-card" data-id="element-303">
      <div className="container flex flex-col items-center justify-between gap-6 py-8 text-center lg:flex-row lg:text-left" data-id="element-304">
        <div className="flex items-start gap-3" data-id="element-305">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary" data-id="element-306">
            <MapPin className="h-5 w-5" data-id="element-307" />
          </span>
          <div data-id="element-308">
            <h2 className="text-base font-semibold text-foreground" data-id="element-309">
              Proudly serving your area and surrounding communities
            </h2>
            <p className="mt-1 text-sm text-muted-foreground" data-id="element-310">
              Enter your address during booking and we’ll confirm delivery
              availability.
            </p>
          </div>
        </div>
        <div className="flex flex-wrap justify-center gap-2" data-id="element-311">
          {highlights.map(item => <Badge key={item.label} variant="secondary" className="gap-1.5 px-3 py-1.5" data-id="element-312">
              <item.icon className="h-3.5 w-3.5 text-primary" data-id="element-313" />
              {item.label}
            </Badge>)}
        </div>
      </div>
    </section>;
}